var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldenHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1.46338C17.538 1.46338 20 3.96832 20 7.47524C20 14.4891 12.5 18.497 10 20C7.5 18.497 0 14.4891 0 7.47524C0 3.96832 2.5 1.46338 5.5 1.46338C7.36 1.46338 9 2.46536 10 3.46733C11 2.46536 12.64 1.46338 14.5 1.46338Z",
    fill: "url(#paint0_linear_8019_118180)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.46733C9 2.46536 7.36 1.46338 5.5 1.46338C2.5 1.46338 0 3.96832 0 7.47524C0 14.0892 6.66916 18.0302 9.52595 19.7184C9.69867 19.8204 9.85746 19.9143 10 20C10.1425 19.9143 10.3013 19.8204 10.4741 19.7184C13.3308 18.0302 20 14.0892 20 7.47524C20 3.96832 17.538 1.46338 14.5 1.46338C12.64 1.46338 11 2.46536 10 3.46733ZM10 18.4993C11.3473 17.7014 13.3248 16.5093 15.0871 14.8445C17.1484 12.8971 18.7402 10.4637 18.7402 7.47524C18.7402 4.64301 16.8006 2.76419 14.5 2.76419C13.0645 2.76419 11.7224 3.55412 10.8774 4.40085L10 5.27996L9.12263 4.40085C8.27757 3.55412 6.93555 2.76419 5.5 2.76419C3.23185 2.76419 1.25984 4.64894 1.25984 7.47524C1.25984 10.4637 2.85161 12.8971 4.91295 14.8445C6.67519 16.5093 8.65267 17.7014 10 18.4993Z",
    fill: "#FEE6B2"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30236 3.39246C1.67395 4.0904 0.758425 4.13696 0 4.24953C0.812598 4.41839 1.76955 4.71489 2.30236 5.28825C3.06079 6.10438 3.06079 7.71107 3.16913 8.78049C3.27748 7.7955 3.48256 6.07624 4.15973 5.28825C4.71597 4.64097 6.05837 4.28705 6.77165 4.24953C6.07643 4.24953 4.67438 3.94252 4.15973 3.49224C3.51642 2.92939 3.25942 0.984991 3.16913 0C3.14205 0.909944 2.93077 2.69452 2.30236 3.39246Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8019_118180",
    x1: 6.61417,
    y1: 1.46338,
    x2: 11.9633,
    y2: 20.9719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.204861,
    stopColor: "#FFE88B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC610"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenHeart);
export default __webpack_public_path__ + "static/media/golden-heart.bfb5604837007c5827b99e2636588b1b.svg";
export { ForwardRef as ReactComponent };